import { CreateButton } from '../../../../components/buttons/CreateButton';
import Modal from 'react-bootstrap/Modal';
import { BDSMForm } from '../../../../components/form/BDSMForm';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { validateEmail } from '../../../../api/ApiEndpoints';

export const EmployeeForm = ({ onClick, onCancel, editingEmployee }) => {

    const { t } = useTranslation('employee');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let isEditing = editingEmployee.id;

    const roles = [
        { name: t('common:SELECT'), value: -1 },
        { name: t('common:roles.DIETIST'), value: 'DIETIST' },
        { name: t('common:roles.CULINARY'), value: 'CULINARY' },
        { name: t('common:roles.MANAGER'), value: 'MANAGER' },
    ];

    const emailValidation = () => {
        return isEditing
            ? Yup.string()
                .email(t('validations:notEmail'))
                .test('test_email', t('validations:sameEmail'), (value) => {
                    return editingEmployee.email === value;
                })
                .required(t('validations:required'))
            : Yup.string()
                .email(t('validations:notEmail'))
                .test('test_email', t('validations:emailTaken'), (value) => {
                    return validateEmail(value)
                        .then((response) => {
                            return !response.data;
                        });
                })
                .required(t('validations:required'));
    };

    const validation = Yup.object().shape({
        name: Yup.string()
            .required(t('validations:required')),
        lastName: Yup.string()
            .required(t('validations:required')),
        email: emailValidation(),
        role: Yup.string().test('test', t('validations:pleaseSelect'), (value) => value !== '-1'),
    });

    const handleSubmit = (values) => {
        onClick(values, editingEmployee.id);
        onClose();
    };

    const onClose = () => {
        onCancel();
        handleClose();
    };

    const getFormModel = () => {
        return {
            initValues: isEditing ?
                {
                    name: editingEmployee.name,
                    lastName: editingEmployee.lastName,
                    email: editingEmployee.email,
                    role: editingEmployee.role,
                }
                :
                {
                    name: '',
                    lastName: '',
                    email: '',
                    role: -1,
                },
            onSubmit: (record) => handleSubmit(record),
            onCancel: () => onClose(),
            validationSchema: validation,
            fieldNames: ['name', 'lastName', 'email', 'role'],
            types: ['text', 'text', 'text', 'select'],
            className: 'mb-3',
            label: [
                t('form.name'),
                t('form.lastName'),
                t('form.email'),
                t('form.roles'),
            ],
            selectData: [null, null, null, roles],
            inputFieldsClass: '',
        };
    };

    return (
        <>
            <CreateButton onClick={handleShow} />
            <Modal show={show} onHide={onClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? t('form.editEmployee') : t('form.newEmployee')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()} />
                </Modal.Body>
            </Modal>
        </>
    );
};